// Copyright 2017-2021 Dgraph Labs, Inc. and Contributors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";

import loader from "../assets/images/loader.svg";

export default function FrameLoading() {
    return (
        <div className="loading-outer">
            <div>
                <img src={loader} alt="Loading Indicator" className="spinner" />
                <div className="text">Fetching result...</div>
            </div>
        </div>
    );
}
